import { Box } from "@mui/material";
import { RefObject } from "react";

interface CommentInputProps {
  contentRef: RefObject<HTMLDivElement>;
  placeholder: string;
  onInput: (event: React.FormEvent<HTMLDivElement>) => void;
  onKeyDown: (event: React.KeyboardEvent) => void;
  onBlur: () => void;
}

export const CommentInput = ({ contentRef, placeholder, onInput, onKeyDown, onBlur }: CommentInputProps) => {
  return (
    <Box
      ref={contentRef}
      contentEditable
      onInput={onInput}
      onKeyDown={onKeyDown}
      onBlur={onBlur}
      sx={{
        width: "calc(100% - 40px)",
        minHeight: "40px",
        padding: "8px 12px",
        borderRadius: "6px",
        background: "transparent",
        color: "var(--Dark---600, #707070)",
        fontFamily: "Montserrat",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "24px",
        outline: "none",
        "&:empty:before": {
          content: `"${placeholder || ""}"`,
          color: "var(--Gray---400, #707070)",
        },
        "& .mention": {
          color: "var(--Green---100, #008B07)",
          fontWeight: 600,
          cursor: "pointer",
          userSelect: "none",
          padding: "0 2px",
        },
      }}
    />
  );
};
